// ----------------------------------------------------------------
import { Link } from '@tanstack/react-router';
// ----------------------------------------------------------------

/**
 * The NotFound component is a page that is displayed when a user tries to access a page that does not exist.
 * It uses the Link component from @tanstack/react-router to navigate to the home page.
 */
function NotFound() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4">
      <h1 className="text-9xl font-bold">404</h1>
      <p className="text-2xl text-gray-500">Page not found</p>
      <Link to="/" className="text-center text-xl text-blue-500 underline">
        Go to home
      </Link>
    </div>
  );
}

export default NotFound;
